import { cn } from '@/shared/lib/utils';
import type { ReactNode } from 'react';

/**
 * Figma subtitle (495:6428) — 카드 · 섹션 제목 줄 (예: "처방 내역 · 월별 처방 등록 … 볼 수 있어요.")
 * - 제목: 18 Bold 검정 (Text/Subtitle/18 | B)
 * - 설명: 13 Regular grey-500 (Text/Body/13 | R)
 * - layout="horizontal"(Type=horizon 495:6429): 한 줄, 간격 8 · 세로 가운데 — 화면에서 주로 쓰는 형태
 * - layout="vertical"(Type=vertical 443:3280): 제목 아래 설명
 * 오른쪽 버튼이 필요하면 actions를 넘긴다 (제목 줄 높이 40에 맞춰 가운데 정렬).
 */
export const Subtitle = ({
  title,
  description,
  layout = 'horizontal',
  actions,
  as: Heading = 'h2',
  className,
}: {
  title: ReactNode;
  description?: ReactNode;
  layout?: 'horizontal' | 'vertical';
  actions?: ReactNode;
  as?: 'h1' | 'h2' | 'h3';
  className?: string;
}) => {
  const text = (
    <div
      className={cn(
        'flex min-w-0',
        layout === 'horizontal'
          ? 'flex-wrap items-center gap-x-2'
          : 'flex-col items-start',
      )}
    >
      <Heading className="text-subtitle-18-b text-fg-primary">{title}</Heading>
      {description && (
        <p className="text-body-13-r text-fg-tertiary">{description}</p>
      )}
    </div>
  );
  if (!actions) return <div className={className}>{text}</div>;
  return (
    <div className={cn('flex min-h-10 items-center gap-4', className)}>
      <div className="min-w-0 flex-1">{text}</div>
      <div className="flex shrink-0 items-center gap-2">{actions}</div>
    </div>
  );
};
